import { render, staticRenderFns } from "./right-bottom.vue?vue&type=template&id=32bff9de&scoped=true&"
import script from "./right-bottom.vue?vue&type=script&lang=js&"
export * from "./right-bottom.vue?vue&type=script&lang=js&"
import style0 from "./right-bottom.vue?vue&type=style&index=0&id=32bff9de&scoped=true&lang=css&"
import style1 from "./right-bottom.vue?vue&type=style&index=1&id=32bff9de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bff9de",
  null
  
)

export default component.exports